import http from '@http';

class KindergartenInvoiceService {
    constructor() {
        if (KindergartenInvoiceService.instance) {
            return KindergartenInvoiceService.instance;
        }

        KindergartenInvoiceService.instance = this;
    }

    getGuardianInvoices(kindergartenId, data) {
        return http.get(`/api/kindergartens/${kindergartenId}/invoices/guardian-invoices`, { params : data}).then(res => res.data);
    }

    getGuardianInvoice(kindergartenId, id) {
        return http.get(`/api/kindergartens/${kindergartenId}/invoices/guardian-invoices/${id}`).then(res => res.data);
    }

    generateGuardianInvoices(kindergartenId) {
        return http.post(`/api/kindergartens/${kindergartenId}/invoices/guardian-invoices`).then(res => res.data);
    }

    recalculateGuardianInvoices(kindergartenId, data) {
        return http.put(`/api/kindergartens/${kindergartenId}/invoices/guardian-invoices/update`, data).then(res => res.data);
    }

    updateGuardianInvoice(kindergartenId, id, data) {
        return http.put(`/api/kindergartens/${kindergartenId}/invoices/guardian-invoices/${id}`, data).then(res => res.data);
    }

    publishGuardianInvoices(kindergartenId, data) {
        return http.put(`/api/kindergartens/${kindergartenId}/invoices/guardian-invoices/publish`, data).then(res => res.data);
    }

}
export default new KindergartenInvoiceService();
